import React, { useState, useEffect } from "react";
import { HiExternalLink, HiOutlineLink } from "react-icons/hi";
import { BaseUrlSurvey } from "../../../../Container/BaseUrl/BaseUrl";
import axios from "axios";
import nodata from "../../../../Assets/images/svg/Data-unavailable.svg";
import { IoCloseCircleOutline } from "react-icons/io5";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import {} from "../../../../Redux/Actions/actions";
import { toaststyle } from "../../../../Utils/toaststyle";
import { IconButton, Stack } from "@mui/material";

const mapStateToProps = (state) => {
  const { data, contactListData } = state;
  return {
    externalChatData: contactListData.externalChatData,
  };
};

const SurveyTab = (props) => {
  const [surveyListUrl, setSurveyListUrl] = useState([]);
  let permission = JSON.parse(localStorage.getItem("permission"));
  const [copied, setCopied] = useState(false);
  const [opensidebarsurvey, setOpensidebarsurvey] = useState(false);
  const [tinySurveyUrl, settinySurveyUrl] = useState("");

  const displayEmail = JSON.stringify(localStorage.getItem("emailDisplay"));

  const handelopenSidebar = () => {
    setOpensidebarsurvey(true);
  };
  const closeopenSidebar = () => {
    setOpensidebarsurvey(false);
  };

  const surveyListApi = async () => {
    await axios
      .get(
        BaseUrlSurvey +
          `/organizations/58?cust_phone=${props.externalChatData.phonenumber}&cust_name=${props.externalChatData.unique_id.username ? props.externalChatData.unique_id.username : ""}&cust_email=${props.externalChatData.email}.com&agent_email=${displayEmail}`,
        {}
      )
      .then((res) => {
        if (res.data.length > 0) {
          setSurveyListUrl(res.data);
        } else {
          setSurveyListUrl([]);
        }
      })
      .catch((error) => {
        setSurveyListUrl([]);
      });
  };

  useEffect(() => {
    {
      permission.map((module) => {
        if (module.moduleId === "SURVEY") {
          const value = module.screen.find(
            (item) => item.screenId === "SURVEY" && item.read && item.write
          );
          surveyListApi();
        }
      });
    }
  }, [props.externalChatData]);

  const copyToClipboard = (newTinyURL) => {
    if (navigator.clipboard && newTinyURL) {
      navigator.clipboard.writeText(newTinyURL);
    }
  };

  const tinyUrlCopyLinkApi = (survey) => {
    const randomNumber = Math.floor(1000000000 + Math.random() * 9000000000);

    const body = {
      url: survey.url,
      domain: "tinyurl.com",
      alias: "Inaipis" + randomNumber,
      tags: " ",
      expires_at: " ",
      description: "string",
    };
    axios
      .post(
        "https://api.tinyurl.com/create?api_token=4hYPbXJbmSkt0KRkzWB1p4DHleUaS7Tm3YIPxw0Z86cvYlAAaMsRySiuWi0x",
        body
      )
      .then((res) => {
        const newTinyURL = res.data.data.tiny_url;

        if (res.status === 200 && newTinyURL) {
          if (navigator.clipboard) {
            navigator.clipboard
              .writeText(newTinyURL)
              .then(() => {
                toast.success("URL copied to clipboard", toaststyle);
              })
              .catch((error) => {
                console.error("Failed to copy text:", error);
                toast.error("Failed to copy URL to clipboard", toaststyle);
              });
          }
        }
      })
      .catch((error) => {
        toast.warning("URL not copied in API", toaststyle);
      });
  };

  const copySurveyUrl = (text) => {
    const regex = /^(.*?id=\d+)/;
    const match = text.match(regex);

    if (match && match[1]) {
      const extractedUrl = match[1];
      settinySurveyUrl(extractedUrl);
      navigator.clipboard
        .writeText(extractedUrl)
        .then(() => {
          setCopied(true);
        })
        .catch((err) => {
          console.error("Unable to copy:", err);
          toast.error("Url failed to copy", toaststyle);
        });
    } else {
    }
  };

  return (
    <>
      <div
        className="d-flex justify-content-start"
        style={{ height: "5px" }}
      ></div>

      <div
        className="historynew CONTACT-LIST-AREA"
        style={{
          height: "calc(100% - 5px)",
          width: "100%",
          overflowY: "scroll",
        }}
      >
        {surveyListUrl.length > 0 ? (
          surveyListUrl.map((survey) => {
            return (
              <div className="card mb-2" key={survey.id}>
                <div
                  className="card-body text-bold"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    fontSize: "13px",
                    padding: ".6rem",
                  }}
                >
                  <p className="mb-0">{survey.survey}</p>
                  <Stack direction={"row"} spacing={0.5}>
                    <IconButton size="small">
                      <HiExternalLink
                        title="open link"
                        style={{
                          cursor: "pointer",
                          color: "#3492D1",
                        }}
                        onClick={() => {
                          window.open(
                            `${survey.url}`,
                            "_blank",
                            "height=600,width=1200"
                          );
                        }}
                      />
                    </IconButton>
                    <IconButton size="small">
                      <HiOutlineLink
                        title="copy link"
                        style={{
                          cursor: "pointer",
                          color: "#3492D1",
                        }}
                        onClick={() => {
                          copySurveyUrl(survey.url);
                          tinyUrlCopyLinkApi(survey);
                          copyToClipboard();
                        }}
                      />
                    </IconButton>
                  </Stack>
                </div>
              </div>
            );
          })
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
              width: "100%",
            }}
          >
            <span className="mx-auto">
              <img
                src={nodata}
                alt="nodata"
                style={{ width: "13rem", userSelect: "none" }}
              />
            </span>
            <span className="mx-auto">
              <h6 className="text-muted mt-2 fs-13">No data found</h6>
            </span>
          </div>
        )}
      </div>

      {opensidebarsurvey && (
        <nav
          className="sidebar_filter"
          style={{
            position: "absolute",
            zIndex: "1",
            left: "14rem",
            width: "66rem",
            top: "48px",
          }}
        >
          <div className="filter col-md-3 shadow p-2">
            <div className="d-flex justify-content-end align-item-end text-end">
              <p className="mb-0">
                <IoCloseCircleOutline
                  onClick={() => {
                    closeopenSidebar();
                  }}
                />
              </p>
            </div>
            {/* {surveyListUrl && (
              <iframe
                target="_blank"
                src={surveyUrl}
                width="100%"
                height="100%"
                title="Embedded Content"
              />
            )} */}
          </div>
        </nav>
      )}
    </>
  );
};

export default connect(mapStateToProps, {})(SurveyTab);
